import React from 'react';
import { ArrowRight } from 'lucide-react';

interface IntroBannerProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

const IntroBanner: React.FC<IntroBannerProps> = ({ suggestions, onSuggestionClick }) => {
  return (
    <div className="max-w-2xl mx-auto text-center pt-8 md:pt-16 px-4">
      <div className="mb-6 inline-flex">
        <img
          src="/brand/logo-secundario.svg"
          alt="dgenny"
          className="h-10 md:h-12 w-auto"
        />
      </div>

      <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-3">
        Fale com a dgenny
      </h1>

      <p className="text-lg text-brand-azul/70 mb-8 max-w-lg mx-auto leading-relaxed">
        Sou a I.A. de compras B2B da dgenny. Posso ajudar a mapear fornecedores, negociar preço e reduzir custo.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-10 max-w-xl mx-auto">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="p-4 text-left border border-border rounded-2xl hover:border-brand-roxo/40 hover:bg-brand-roxo/5 transition-colors"
            onClick={() => onSuggestionClick(suggestion)}
          >
            <div className="flex items-center gap-2">
              <span className="flex-1 text-brand-azul text-sm">{suggestion}</span>
              <ArrowRight className="h-4 w-4 text-brand-roxo flex-shrink-0" />
            </div>
          </button>
        ))}
      </div>

      <div className="border-t border-border pt-8 mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 text-left max-w-3xl mx-auto">
        <div>
          <h3 className="font-display font-bold mb-1.5 text-brand-azul">Descobre</h3>
          <p className="text-brand-azul/70 text-sm leading-relaxed">
            Mapeia fornecedores relevantes para sua compra — além da sua base atual.
          </p>
        </div>

        <div>
          <h3 className="font-display font-bold mb-1.5 text-brand-azul">Negocia</h3>
          <p className="text-brand-azul/70 text-sm leading-relaxed">
            Conversa com dezenas de fornecedores em paralelo no WhatsApp.
          </p>
        </div>

        <div>
          <h3 className="font-display font-bold mb-1.5 text-brand-azul">Decide</h3>
          <p className="text-brand-azul/70 text-sm leading-relaxed">
            Equaliza as propostas e entrega a decisão na sua mão.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IntroBanner;
